import React, { useContext } from "react";
import { DataContext } from "../contexts/DataContext";

import placeholderImage from "../assets/default_news_placeholder.png";

const ArticleLink = () => {
  const { articles, pathway, config } = useContext(DataContext);

  let featuredSponsoredList = [];
  let regularList = [];
  let mergedList = [];

  if (articles.length) {
    articles.map((article) => {
      const currentDate = new Date().toJSON().slice(0, 10);
      const expiryDate = article.attributes.Expires;

      if (
        ((config.siteName === "BOL" && article.attributes.SponsoredBOL) ||
          (config.siteName === "TrustPMS" &&
            article.attributes.SponsoredPMS)) &&
        currentDate < expiryDate
      ) {
        article.isHeadlineSponsored = true;
        featuredSponsoredList.push(article);
      } else if (
        ((config.siteName === "BOL" && article.attributes.SponsoredBOL) ||
          (config.siteName === "TrustPMS" &&
            article.attributes.SponsoredPMS)) &&
        currentDate > expiryDate
      ) {
        regularList.push(article);
      } else {
        regularList.push(article);
      }
    });

    mergedList = mergedList.concat(featuredSponsoredList, regularList);
  }

  return !articles.length ? (
    <div className="loading_msg">Loading...</div>
  ) : (
    <>
      {config.siteName === "sbg.co.uk" ? (
        <div className="container">
          <div className="news-headlines news-headlines-layout-horizontal row">
            {mergedList.map((article) => (
              <Article
                article={article}
                pathway={pathway}
                newsUrl={config.newsUrl}
                siteName={config.siteName}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="news-headlines news-headlines-layout-horizontal row">
          {mergedList.map((article) => (
            <Article
              article={article}
              pathway={pathway}
              newsUrl={config.newsUrl}
              siteName={config.siteName}
            />
          ))}
        </div>
      )}
    </>
  );
};

const Article = ({ article, pathway, newsUrl, siteName }) => {
  return (
    <article
      className={`news_container col-lg-4 col-md-6 ${
        article.isHeadlineSponsored ? "headline-sponsored-article" : ""
      }`}
      key={article.id}
    >
      <div className="card_wrapper">
        <a
          href={
            newsUrl +
            (article.attributes.Slug
              ? article.attributes.Slug
              : "id=" + article.id)
          }
          className="news-headline-link news_link"
        >
          <div className="news-headline-content">
            <div className="news-headline-image-container news_image">
              <img
                src={
                  article.attributes.Image.data
                    ? pathway + article.attributes.Image.data.attributes.url
                    : process.env.NODE_ENV === "development"
                    ? placeholderImage
                    : process.env.REACT_APP_PLACEHOLDER_IMG_PATH
                }
                alt={article.attributes.Headline}
              />
            </div>
            <div>
              <h4 className="news-headline-title homepage_news_headline">
                {article.attributes.Headline}
              </h4>
            </div>
            {article.attributes.Provider.data !== null ? (
              <div className="news-headline-provider provider_logo">
                {(siteName === "BOL" && article.attributes.SponsoredBOL) ||
                (siteName === "TrustPMS" && article.attributes.SponsoredPMS) ? (
                  <h5 class="sponsor">Sponsored by</h5>
                ) : null}
                <img
                  src={
                    pathway +
                    article.attributes.Provider.data.attributes.Logo.data
                      .attributes.url
                  }
                  alt={
                    "Story provided by" +
                    article.attributes.Provider.data.attributes.Name
                  }
                />
              </div>
            ) : null}
          </div>
        </a>
      </div>
    </article>
  );
};

export default ArticleLink;
